<template>
    <div>
        <div class="header_unit header_bg_blue">
            <div class="header_box">
                <div class="menu_left">
                    <router-link :to="{ name: 'top' ,
                    params: { brandPath: $route.params.brandPath}} ">TOPへ</router-link>
                </div>
                <div class="menu_center">
                    <p class="menu_center_tex_s">{{menuNameUpper}}</p>
                    <p class="menu_center_tex_l">{{menuNameLower}}</p>
                </div>
                <div class="menu_right">
                </div>
            </div>
        </div>
        <DailyCheckMenu />
    </div>
</template>

<script>
    // @ is an alias to /src
    import DailyCheckMenu from '@/app/components/DailyCheckMenu.vue'

    export default {
        name: 'dailyCheckMenuIndex',
        components: {
            DailyCheckMenu
        },
        props: {
            menuId: Number,
        },
        computed: {
            menuNameUpper: function () {
                const button = this.$store.getters['buttons/topButton'](this.menuId)
                return 'upperButtonName' in button ? button.upperButtonName : ''
            },
            menuNameLower: function () {
                const button = this.$store.getters['buttons/topButton'](this.menuId)
                return 'lowerButtonName' in button ? button.lowerButtonName : ''
            }
        },
    }
</script>
